import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Box, Button, Checkbox, FormControlLabel, IconButton, Tooltip } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import { withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    saveCard: {
        marginRight: 0,
    },
    saveCardInfo: {
        padding: 8,
    },
})

class BeadPayFrame extends React.Component {
    state = {
        paymentSaveCard: this.props.paymentSaveCard,
    }

    componentDidMount = () => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://secure.nmi.com/token/Collect.js'
        script.dataset.tokenizationKey = this.props.processorSettings.tokenization_key

        document.head.appendChild(script)
    }

    componentWillUnmount = () => {
        document.head.querySelector('script[src="https://secure.nmi.com/token/Collect.js"]')?.remove()
    }

    // unused?
    finishSubmit = async (token) => {
        const { paymentSaveCard } = this.state

        // console.log(data)

        try {
            this.props.onTokenize(data.CARDREFERENCE, data.CARDEXPIRY, data.MASKEDCARDNUMBER.substr(-4), data.CARDTYPE, null, paymentSaveCard)

        } catch (err) {
            this.props.showError(err)
        }
    }

    handlePaymentSaveChange = () => {
        const { paymentSaveCard } = this.state

        this.setState({
            paymentSaveCard: !paymentSaveCard,
        })
    }

    render() {
        const { className, classes, forceSaveCard, saveCardLabel } = this.props
        const { paymentSaveCard } = this.state

        return (
            <Box className={className}>
                <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved.">
                    <FormControlLabel
                        className={classes.saveCard}
                        disabled={forceSaveCard}
                        control={
                            <Checkbox
                                color="primary"
                                checked={paymentSaveCard}
                                onClick={this.handlePaymentSaveChange}
                            />
                        }
                        label={saveCardLabel || 'Save card on file (secure)'}
                    />
                </Tooltip>
                <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved." enterTouchDelay={0} leaveTouchDelay={10000}>
                    <IconButton className={classes.saveCardInfo} size="large">
                        <HelpOutlineIcon />
                    </IconButton>
                </Tooltip><br />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        window.CollectJS.configure({
                            paymentType: 'cc',
                            callback: (token_data) => {
                                this.props.onTokenize(token_data.token, token_data.card.exp, token_data.card.number.substr(-4), token_data.card.type, null, paymentSaveCard)
                            },
                        })

                        window.CollectJS.startPaymentRequest()
                    }}
                >
                    Enter card information
                </Button>
            </Box>
        )
    }
}

export default withAppContext(withStyles(styles, { withTheme: true })(BeadPayFrame))
